import type { SVGProps } from 'react'

interface CorporationIconProps extends SVGProps<SVGSVGElement> {}

export function CorporationIcon(props: CorporationIconProps) {
  return (
    <svg
      width="34"
      height="39"
      viewBox="0 0 34 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8977 3.14746H20.1016V4.04268H13.8977V3.14746Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7517 6.91638H13.5932V8.19654H12.7517V6.91638Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.583 6.91638H17.4156V8.19654H16.583V6.91638Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.4062 6.91638H21.2478V8.19654H20.4062V6.91638Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7517 10.9985H13.5932V12.2877H12.7517V10.9985Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.583 10.9985H17.4156V12.2877H16.583V10.9985Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.4062 10.9985H21.2478V12.2877H20.4062V10.9985Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7517 15.0897H13.5932V16.3788H12.7517V15.0897Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.583 15.0897H17.4156V16.3788H16.583V15.0897Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.4062 15.0897H21.2478V16.3788H20.4062V15.0897Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.83398 10.5688H7.67549V11.858H6.83398V10.5688Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.83398 14.66H7.67549V15.9491H6.83398V14.66Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.83398 18.7511H7.67549V20.0313H6.83398V18.7511Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.3323 10.5688H27.1648V11.858H26.3323V10.5688Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.3323 14.66H27.1648V15.9491H26.3323V14.66Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.3323 18.7511H27.1648V20.0313H26.3323V18.7511Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.4338 18.9929H19.0094V22.1978H17.4338V18.9929Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.9902 18.9929H16.5748V22.1978H14.9902V18.9929Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.2242 9.16333L24.2646 7.08643V22.2067L29.2242 22.1977V9.16333ZM28.0246 20.461C28.0246 20.7027 27.8276 20.8907 27.5949 20.8907H25.9029C25.6701 20.8907 25.4732 20.6937 25.4732 20.461V18.3214C25.4732 18.0887 25.6612 17.8917 25.9029 17.8917H27.5949C27.8276 17.8917 28.0246 18.0887 28.0246 18.3214V20.461ZM28.0246 16.3788C28.0246 16.6116 27.8276 16.8085 27.5949 16.8085H25.9029C25.6701 16.8085 25.4732 16.6205 25.4732 16.3788V14.2392C25.4732 13.9975 25.6612 13.8095 25.9029 13.8095H27.5949C27.8276 13.8095 28.0246 14.0065 28.0246 14.2392V16.3788ZM28.0246 12.2876C28.0246 12.5204 27.8276 12.7174 27.5949 12.7174H25.9029C25.6701 12.7174 25.4732 12.5294 25.4732 12.2876V10.1481C25.4732 9.90636 25.6612 9.71837 25.9029 9.71837H27.5949C27.8276 9.71837 28.0246 9.91532 28.0246 10.1481V12.2876Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.7349 7.07751L4.77539 9.15442V22.1888L9.7349 22.1978V7.07751ZM8.53531 20.461C8.53531 20.7027 8.33836 20.8907 8.1056 20.8907H6.41364C6.18088 20.8907 5.98394 20.6938 5.98394 20.461V18.3215C5.98394 18.0887 6.17193 17.8918 6.41364 17.8918H8.1056C8.34731 17.8918 8.53531 18.0887 8.53531 18.3215V20.461ZM8.53531 16.3788C8.53531 16.6116 8.33836 16.8085 8.1056 16.8085H6.41364C6.18088 16.8085 5.98394 16.6205 5.98394 16.3788V14.2393C5.98394 13.9976 6.17193 13.8096 6.41364 13.8096H8.1056C8.34731 13.8096 8.53531 14.0065 8.53531 14.2393V16.3788ZM8.53531 12.2877C8.53531 12.5204 8.33836 12.7174 8.1056 12.7174H6.41364C6.18088 12.7174 5.98394 12.5294 5.98394 12.2877V10.1481C5.98394 9.90641 6.17193 9.71841 6.41364 9.71841H8.1056C8.34731 9.71841 8.53531 9.91536 8.53531 10.1481V12.2877Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.49043 34.14H5.62573C7.38931 35.8857 9.54679 37.2285 11.9549 38.0163C10.63 37.0584 9.45727 35.7335 8.49043 34.14Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5022 34.14C11.0062 36.4228 12.913 37.9715 14.963 38.5893C13.9514 37.4255 13.2979 35.6171 12.8682 34.14H9.5022Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7637 34.14C14.1307 35.3665 15.3393 38.822 16.9954 38.822C18.6605 38.822 19.8601 35.3665 20.2361 34.14H13.7637Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.515 34.14H21.131C20.7013 35.6171 20.0389 37.4344 19.0183 38.6072C21.0952 37.9984 23.002 36.4407 24.515 34.14Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.0979 38.0074C24.4792 37.2106 26.6277 35.8767 28.3823 34.14H25.5266C24.5598 35.7246 23.396 37.0495 22.0979 38.0074Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.4987 23.0571C28.4719 24.6775 28.2928 26.2531 27.9795 27.7391H32.3661C32.8584 26.262 33.1449 24.6864 33.1897 23.0571H28.4987Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.6483 23.0571H22.5366C22.5187 24.6685 22.4382 26.2352 22.2949 27.7391H27.1112C27.4335 26.2352 27.6215 24.6596 27.6483 23.0571Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.6681 23.0571C18.5527 23.0571 15.4374 23.0571 12.322 23.0571C12.3399 24.6685 12.4205 26.2441 12.5727 27.7391H21.4264C21.5786 26.2441 21.6592 24.6685 21.6681 23.0571Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.35059 23.0571C6.38639 24.6596 6.57439 26.2352 6.89667 27.7391H11.704C11.5608 26.2441 11.4712 24.6685 11.4623 23.0571H6.35059Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.50052 23.0571H0.80957C0.854331 24.6864 1.1408 26.262 1.63317 27.7391H6.01974C5.70642 26.2531 5.52737 24.6775 5.50052 23.0571Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.21673 28.5985H1.94653C2.63585 30.3263 3.61164 31.9019 4.81123 33.2805H7.99821C7.24623 31.875 6.64643 30.2994 6.21673 28.5985Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6358 33.2805C12.2777 31.8661 12.0002 30.2815 11.8033 28.5985H7.1123C7.55096 30.2905 8.18657 31.875 8.98331 33.2805H12.6358Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.4772 33.2805C20.8442 31.875 21.1307 30.2905 21.3366 28.5985H12.6709C12.8768 30.2905 13.1633 31.875 13.5303 33.2805H20.4772Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.8967 28.5985H22.1968C21.9999 30.2815 21.7223 31.8661 21.3643 33.2805H25.0347C25.8314 31.875 26.4581 30.2905 26.8967 28.5985Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.01 33.2805H29.188C30.3966 31.9019 31.3724 30.3263 32.0527 28.5985H27.7825C27.3618 30.2994 26.753 31.875 26.01 33.2805Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1308 18.5722C14.1308 18.3394 14.3188 18.1425 14.5605 18.1425H19.4484C19.6901 18.1425 19.8781 18.3394 19.8781 18.5722V22.1978H23.4053V4.91113H20.5317H13.4684H10.5947V22.1978H14.1308V18.5722ZM19.5469 6.48672C19.5469 6.24501 19.7349 6.05701 19.9766 6.05701H21.6775C21.9192 6.05701 22.1072 6.24501 22.1072 6.48672V8.62629C22.1072 8.85905 21.9103 9.056 21.6775 9.056H19.9766C19.7349 9.056 19.5469 8.85905 19.5469 8.62629V6.48672ZM19.5469 10.5779C19.5469 10.3362 19.7349 10.1482 19.9766 10.1482H21.6775C21.9192 10.1482 22.1072 10.3362 22.1072 10.5779V12.7174C22.1072 12.9502 21.9103 13.1471 21.6775 13.1471H19.9766C19.7349 13.1471 19.5469 12.9502 19.5469 12.7174V10.5779ZM19.5469 14.669C19.5469 14.4273 19.7349 14.2393 19.9766 14.2393H21.6775C21.9192 14.2393 22.1072 14.4273 22.1072 14.669V16.8086C22.1072 17.0413 21.9103 17.2383 21.6775 17.2383H19.9766C19.7349 17.2383 19.5469 17.0503 19.5469 16.8086V14.669ZM15.7243 6.48672C15.7243 6.24501 15.9123 6.05701 16.154 6.05701H17.846C18.0877 6.05701 18.2757 6.24501 18.2757 6.48672V8.62629C18.2757 8.85905 18.0877 9.056 17.846 9.056H16.154C15.9123 9.056 15.7243 8.85905 15.7243 8.62629V6.48672ZM15.7243 10.5779C15.7243 10.3362 15.9123 10.1482 16.154 10.1482H17.846C18.0877 10.1482 18.2757 10.3362 18.2757 10.5779V12.7174C18.2757 12.9502 18.0877 13.1471 17.846 13.1471H16.154C15.9123 13.1471 15.7243 12.9502 15.7243 12.7174V10.5779ZM15.7243 14.669C15.7243 14.4273 15.9123 14.2393 16.154 14.2393H17.846C18.0877 14.2393 18.2757 14.4273 18.2757 14.669V16.8086C18.2757 17.0413 18.0877 17.2383 17.846 17.2383H16.154C15.9123 17.2383 15.7243 17.0503 15.7243 16.8086V14.669ZM11.9017 6.48672C11.9017 6.24501 12.0897 6.05701 12.3315 6.05701H14.0234C14.2651 6.05701 14.4531 6.24501 14.4531 6.48672V8.62629C14.4531 8.85905 14.2562 9.056 14.0234 9.056H12.3315C12.0897 9.056 11.9017 8.85905 11.9017 8.62629V6.48672ZM11.9017 10.5779C11.9017 10.3362 12.0897 10.1482 12.3315 10.1482H14.0234C14.2651 10.1482 14.4531 10.3362 14.4531 10.5779V12.7174C14.4531 12.9502 14.2562 13.1471 14.0234 13.1471H12.3315C12.0897 13.1471 11.9017 12.9502 11.9017 12.7174V10.5779ZM12.3315 17.2383C12.0897 17.2383 11.9017 17.0503 11.9017 16.8086V14.669C11.9017 14.4273 12.0897 14.2393 12.3315 14.2393H14.0234C14.2651 14.2393 14.4531 14.4273 14.4531 14.669V16.8086C14.4531 17.0413 14.2562 17.2383 14.0234 17.2383H12.3315Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.4339 0.748309C17.4339 0.5066 17.2459 0.318604 17.0042 0.318604C16.7625 0.318604 16.5745 0.5066 16.5745 0.748309V2.28808H17.4339V0.748309Z"
        fill="currentColor"
      />
    </svg>
  )
}
